import { StyleSheet, View } from 'react-native';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg';
import { TranslateProp } from '../../common-types';
import { GymResolver } from '../../services/GymResolver';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import MultiStyleText from '../../ui/components/MultiStyleText';
import { BreakoutLinkText } from '../../ui/components/BreakoutLinkText';

interface IProps {
  gymName: string;
  t: TranslateProp;
}

const warningIconSize = 24;
const marginAfterIconToText = 10;

const styles = StyleSheet.create({
  container: {
    padding: defaultScale(10),
    borderRadius: defaultScale(10),
    backgroundColor: Theme.GREY_LIGHT,
    display: 'flex',
    flexDirection: 'column',
  },
  warningRow: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  warningIconContainer: {
    width: defaultScale(warningIconSize),
  },
  text: {
    ...Theme.textStyle.small,
    color: Theme.GREY_DARK,
    marginLeft: defaultScale(marginAfterIconToText),
    flex: 1,
  },
  availabilityContainer: {
    marginTop: defaultScale(8),
    marginLeft: defaultScale(warningIconSize + marginAfterIconToText),
  },
  link: {
    ...Theme.textStyle.small,
    color: Theme.GREY_DARK,
  },
});

export function OfficeScheduleWarning({
  t,
  gymName,
}: IProps) {
  const gym = GymResolver.getByName(gymName);
  const availabilityLink = gym.officeGymConfig?.availabilityLink;

  return (
    <View style={styles.container}>
      <View style={styles.warningRow}>
        <View style={styles.warningIconContainer}>
          <WarningIcon />
        </View>

        <MultiStyleText
          templateString={t('bookings:checkOfficeSchedule')}
          styleKeys={[
            { keyName: 'gymName', keyValue: gym.displayName, style: Theme.textStyle.bodyCopyBold },
          ]}
          normalStyle={styles.text}
        />
      </View>

      {availabilityLink && (
        <View style={[styles.warningRow, styles.availabilityContainer]}>
          <BreakoutLinkText
            linkText='Availability info'
            url={availabilityLink}
            textStyle={styles.link}
          />
        </View>
      )}
    </View>
  );
}
